import React from 'react'

export default ({className='', children, ...props}) => {

    return (
        <div {...props}
             className={className}>
            {children}
        </div>
    )
}